<template>
  <!--司法服务介绍-->
  <div class="body">
    <div class="service-box service-con1">
      <service-tabbar :returnService="returnService" />
      <div class="con">
        <h1 class="service-title">
          同司法机构系统底层打通，确保电子数据成为 “ 有效的电子证据 ”
        </h1>
        <p class="service-desc">
          邀请权威司法机构加入保全链节点，若遇纠纷，存证的电子数据不用任何附加说明，“
          公证处 ” “ 仲裁委 ” “ 互联网法院 ”等司法机构直接采信
        </p>
        <img class="img" src="/images/judicialService/img1.png" />
      </div>
    </div>
    <div class="service-box service-con2">
      <h1 class="service-title">足不出户，证书邮寄到家</h1>
      <p class="service-desc">
        为司法审判提供多种电子证据，支持三家以上司法机构在线申请出证
      </p>
      <div class="service-con2-list">
        <div class="item">
          <h3 class="title">公证书</h3>
          <img class="img" src="/images/judicialService/img2-1.png" />
          <p class="desc">
            公证书，是指公证处根据当事人申请，依照事实和法律，按照法定程序制作的具有特殊法律效力的司法证明书，可作为呈堂证据。
          </p>
        </div>
        <div class="item">
          <h3 class="title">E证据</h3>
          <img class="img" src="/images/judicialService/img2-2.png" />
          <p class="desc">
            E证据，是一整套证明材料的总称，有电子版和纸质版两种可供选择，可在司法纠纷中作为证据，提交给法律机关，增加审判胜算。
          </p>
        </div>
        <div class="item">
          <h3 class="title">保管函</h3>
          <img class="img" src="/images/judicialService/img2-3.png" />
          <p class="desc">
            用 君子签签署的每一份文件，文件实时同步存证至公证处的
            “保全链”节点，若遇纠纷，可由公证处颁发保管函，作为呈堂证据。
          </p>
        </div>
        <div class="item">
          <h3 class="title">电子签署技术报告</h3>
          <img class="img" src="/images/judicialService/img2-4.png" />
          <p class="desc">
            君子签将签署文件哈希摘要通过区块链存证，同步至相关司法机构节点，若遇纠纷，君子签可为签署方出具电子签署技术报告作为证据。
          </p>
        </div>
      </div>
    </div>
    <div class="service-box service-con3">
      <h1 class="service-title">四大互联网司法通道，确保文件签署无忧</h1>
      <p class="service-desc">
        与仲裁委、互联网法院等多个司法通道对接，实现电子数据实时存储，不被篡改，提升争议解决效率
      </p>
      <div class="service-con3-list">
        <div class="item">
          <img class="img" src="/images/judicialService/img3-1.png" />
          <h3 class="title">代理维权</h3>
          <p class="desc">
            遭遇纠纷，需要追回损失，又不想自己麻烦，可以把案件委托给我们
          </p>
        </div>
        <div class="item">
          <img class="img" src="/images/judicialService/img3-2.png" />
          <h3 class="title">在线智能仲裁</h3>
          <p class="desc">
            前置拟定仲裁模板，违约后存证证据通过系统直达仲裁委，完成快速下裁
          </p>
        </div>
        <div class="item">
          <img class="img" src="/images/judicialService/img3-3.png" />
          <h3 class="title">网络赋强公证</h3>
          <p class="desc">
            依托于电子签署，签署贸易协议时同步申请赋强公证，一旦违约可在线申请执行
          </p>
        </div>
        <div class="item">
          <img class="img" src="/images/judicialService/img3-4.png" />
          <h3 class="title">互联网法院</h3>
          <p class="desc">存证证据同步法院司法区块链，互联网法院交案直接调用</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ServiceTabbar from "@/components/judicialService/tabbar";
export default {
  name: "arbitration",
  components: { ServiceTabbar },
  methods: {},
  mounted() {},
  created() {
    let _returnService = this.$route.query
      ? this.$route.query.returnService
      : null;
    if (_returnService) {
      this.returnService = _returnService;
    }
  },
  data() {
    return {
      returnService: 0
    };
  }
};
</script>

<style lang="less" scoped>
.body {
  width: 100%;
  padding-top: 36px;
}
.service-box {
  width: 1200px;
  position: relative;
  height: auto;
  margin: 0 auto 50px;
  background: #ffffff;
  border-radius: 14px;
}
.service-title {
  font-size: 26px;
  font-family: Source Han Sans SC;
  font-weight: bold;
  line-height: 30px;
  color: #290202;
  padding-bottom: 8px;
  text-align: center;
}
.service-desc {
  font-size: 14px;
  font-family: Source Han Sans SC;
  font-weight: 400;
  line-height: 20px;
  color: rgba(41, 2, 2, 0.45);
  padding-bottom: 55px;
  text-align: center;
}
.service-con1 {
  padding: 20px;
  .con {
    width: 100%;
    padding: 80px 0 30px;
    border-radius: 8px;
  }
  .img {
    width: 100%;
    height: auto;
    display: block;
  }
}
.service-con2,
.service-con3 {
  padding-top: 50px;
}
.service-con2-list {
  width: 100%;
  display: flex;
  padding-bottom: 30px;
  .item {
    width: 25%;
    height: auto;
    box-sizing: border-box;
    padding: 0 25px;
    position: relative;
    &::after {
      content: "";
      width: 48px;
      height: 23px;
      background: url("/images/judicialService/icon-right.png") no-repeat center
        center;
      background-size: 100% 100%;
      display: block;
      position: absolute;
      top: 50%;
      margin-top: -12px;
      right: -16px;
    }
    &:last-child::after {
      display: none;
    }
  }
  .title {
    font-size: 16px;
    font-family: Source Han Sans SC;
    font-weight: bold;
    line-height: 43px;
    color: #290202;
    text-align: center;
  }
  .img {
    width: 100%;
    height: auto;
  }
  .desc {
    font-size: 12px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    line-height: 22px;
    color: rgba(41, 2, 2, 0.45);
    text-align: justify;
    padding-top: 10px;
  }
}
.service-con3-list {
  width: 100%;
  display: flex;
  padding-bottom: 60px;
  .item {
    width: 25%;
    height: auto;
    box-sizing: border-box;
    padding: 0 56px;
  }
  .title {
    font-size: 16px;
    font-family: Source Han Sans SC;
    font-weight: bold;
    line-height: 43px;
    color: #290202;
    text-align: center;
    padding-top: 30px;
  }
  .img {
    width: 140px;
    height: auto;
    display: block;
    margin: 0 auto;
  }
  .desc {
    font-size: 12px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    line-height: 20px;
    color: rgba(41, 2, 2, 0.45);
    text-align: justify;
  }
}
</style>



// WEBPACK FOOTER //
// pages/judicialService/introduce.vue